<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1" id="_idContainer000">
<p class="author">Meet the author and illustrator Ivo ten Voorde, with</p>
<p class="author">stories so bold,</p>
<p class="author">Gather around because many tales are yet untold.</p>
<p class="author">With creativity as his sail, dreams his vast sea,</p>
<p class="author">He sets out to share his tales, as a gift to you with glee.</p>
<p class="author">Inspired by his daughter, whose imagination soars,</p>
<p class="author">Together they craft tales under the wide-open</p>
<p class="author">skies, outdoors.</p>
<p class="author">Joy and wonder in each story they weave,</p>
<p class="author">Magic in words, just believe and receive.</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer002">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035872305_txt3.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer003">
<p class="c-heading ParaOverride-1">Copyright © Ivo ten Voorde 2024</p>
<p class="c-normal ParaOverride-1">The right of <span class="CharOverride-1">Ivo ten Voorde</span> to be identified as author of this work has been asserted by the author in accordance with sections 77 and 78 of the Copyright, Designs and Patents Act 1988.</p>
<p class="c-normal ParaOverride-1">All rights reserved. No part of this publication may be reproduced, stored in a retrieval system, or transmitted in any form or by any means, electronic, mechanical, photocopying, recording, or otherwise, without the prior permission of the publishers.</p>
<p class="c-normal ParaOverride-1">Any person who commits any unauthorised act in relation to this publication may be liable to criminal prosecution and civil claims for damages.</p>
<p class="c-normal ParaOverride-1">A CIP catalogue record for this title is available from the British Library.</p>
<p class="c-normal">ISBN 9781035872305 (Paperback)</p>
<p class="c-normal">ISBN 9781035872312 (Hardback)</p>
<p class="c-normal">ISBN 9781035872336 (ePub e-book)</p>
<p class="c-normal ParaOverride-1">ISBN 9781035872329 (Audiobook)</p>
<p class="c-normal ParaOverride-1">www.austinmacauley.com</p>
<p class="c-normal">First Published 2024</p>
<p class="c-normal">Austin Macauley Publishers Ltd®</p>
<p class="c-normal">1 Canada Square </p>
<p class="c-normal">Canary Wharf </p>
<p class="c-normal">London</p>
<p class="c-normal">E14 5AA</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer004">
<p class="ded-next">Thanks to my daughter Charlotte.</p>
<p class="ded">Thanks to Dave Birss for encouragement and on how to use available tools.</p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer006">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035872305_txt6.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer008">
<p class="book-text-next">In a town where the sun always smiled,</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/85973_-_Lily_-_01.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer010">
<p class="book-text-next">Lived Lily, a girl with a heart full of wild.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-3" role="presentation" src="image/85973_-_Lily_-_03.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer012">
<p class="book-text-next">Each day she’d set off on her way to school,</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-4" role="presentation" src="image/85973_-_Lily_-_04.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer014">
<p class="book-text-next">With a backpack of books and a heart so cool.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-5" role="presentation" src="image/85973_-_Lily_-_05.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer016">
<p class="book-text-next">One fine afternoon, as she walked by the lane,</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-6" role="presentation" src="image/85973_-_Lily_-_06.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer018">
<p class="book-text-next">She saw a white cat in a prickly chain.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-7" role="presentation" src="image/85973_-_Lily_-_07.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer020">
<p class="book-text-next">“Oh my!” cried Lily,</p>
<p class="book-text">“I must help you, you see.”</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-8" role="presentation" src="image/85973_-_Lily_-_08.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer022">
<p class="book-text-next">No kitty should ever be stuck in a tree!</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-9" role="presentation" src="image/85973_-_Lily_-_09.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer024">
<p class="book-text-next">With gentle hands, she set the cat free, </p>
<p class="book-text">And the cat, named Whiskers, purred happily.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-4" role="presentation" src="image/85973_-_Lily_-_10.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer026">
<p class="book-text-next">Thank you dear Lily, for helping me out,</p>
<p class="book-text">You’re a friend so true,</p>
<p class="book-text">There can be no doubt! said the cat.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-10" role="presentation" src="image/85973_-_Lily_-_11.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer028">
<p class="book-text-next">Ah, how can you talk?</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-7" role="presentation" src="image/85973_-_Lily_-_12.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer030">
<p class="book-text-next">“Well, your heart is made of gold!” said the cat</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-11" role="presentation" src="image/85973_-_Lily_-_13.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer032">
<p class="book-text-next">With whiskers by her side, they began to roam, through streets and alleys, far from home.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-12" role="presentation" src="image/85973_-_Lily_-_14.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer034">
<p class="book-text-next">They met Tango, a tabby with eyes so bright, who joined their adventure with all his might.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-13" role="presentation" src="image/85973_-_Lily_-_15.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer036">
<p class="book-text-next">They learned from each other, as friends often do.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-14" role="presentation" src="image/85973_-_Lily_-_16.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer038">
<p class="book-text-next">About courage, joy, and living life anew.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-15" role="presentation" src="image/85973_-_Lily_-_17.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer040">
<p class="book-text-next">Professor Paws, a wise old cat they found, in the library, where knowledge abound.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-16" role="presentation" src="image/85973_-_Lily_-_18.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer042">
<p class="book-text-next">He taught them about the wonders of learning, and the joy it brings forever returning.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-17" role="presentation" src="image/85973_-_Lily_-_19.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer044">
<p class="book-text-next">As the sun began to set in the sky, they arrived at home with a twinkle in their eye.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-18" role="presentation" src="image/85973_-_Lily_-_20.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer046">
<p class="book-text-next">And so, dear children, remember the tale, of a journey of friendship, love and fun.</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-19" role="presentation" src="image/85973_-_Lily_-_21.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer048">
<p class="book-text-next">For adventure awaits,for everyone!</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-3"><img alt="" class="_idGenObjectAttribute-20" role="presentation" src="image/85973_-_Lily_-_22.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer050">
<p class="image"><img alt="" class="_idGenObjectAttribute-1" role="presentation" src="image/9781035872305_txt28.jpg"/></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer052">
<p class="book-text-next">A lovely story about a little girl named “Lilly”, who gets rewarded for being kind!</p>
<p class="book-text">Join her also on her next adventures and I hope you enjoyed this book!</p>
<p class="Basic-Paragraph ParaOverride-2"><span class="CharOverride-2"><img alt="" class="_idGenObjectAttribute-17" role="presentation" src="image/85973_-_Lily_-_24.jpg"/></span></p>
</div>
<div class="_idGenObjectStyleOverride-1" id="_idContainer053">
<p class="end">The End!</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled-1.vue?2a20d226